"use client";

import { c as _c } from "react/compiler-runtime";
import { parseAsJson, useQueryState } from "nuqs";
import { z } from "zod";
import { constructTraits, queryTraitSchema } from "../../components/search/construct-traits";
import { QUERY_PARAM_KEYS } from "./keys";
const schema = z.array(queryTraitSchema);
export function useTraitsQueryParam() {
  const $ = _c(15);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = parseAsJson(schema.parse).withDefault([]);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [values, setValues] = useQueryState(QUERY_PARAM_KEYS.traits, t0);
  let t1;
  if ($[1] !== setValues || $[2] !== values) {
    t1 = async function onSelectTrait(traitType, value) {
      const traits = constructTraits(values, traitType, value);
      await setValues(traits.length > 0 ? traits : null);
    };
    $[1] = setValues;
    $[2] = values;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onSelectTrait = t1;
  let t2;
  if ($[4] !== setValues || $[5] !== values) {
    t2 = async function onRemoveTraitType(traitType_0) {
      const traits_0 = values.filter(trait => trait.traitType !== traitType_0);
      await setValues(traits_0.length > 0 ? traits_0 : null);
    };
    $[4] = setValues;
    $[5] = values;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const onRemoveTraitType = t2;
  let t3;
  if ($[7] !== values[0]) {
    t3 = values[0] ? {
      traitType: values[0]?.traitType,
      value: values[0]?.values[0]
    } : undefined;
    $[7] = values[0];
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== onRemoveTraitType || $[10] !== onSelectTrait || $[11] !== setValues || $[12] !== t3 || $[13] !== values) {
    t4 = {
      traits: values,
      onSelectTrait,
      onSetTraits: setValues,
      onRemoveTraitType,
      firstTrait: t3
    };
    $[9] = onRemoveTraitType;
    $[10] = onSelectTrait;
    $[11] = setValues;
    $[12] = t3;
    $[13] = values;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}